import React from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from './home/Navbar';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';

function DemoAdminSuite() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const kpis = t('demo_admin_suite.kpis', { returnObjects: true });

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-ink font-sans text-white antialiased">
      <Navbar />
      
      {/* Sección 1: Video */}
      <section className="w-full bg-ink pt-28 pb-16">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-8 text-white">{t('demo_admin_suite.title')}</h2>
          <div className="w-full aspect-video rounded-2xl overflow-hidden border border-line shadow-2xl">
            <img 
              src="/adminsuitegif.gif" 
              alt="Admin Suite Demo"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* Sección 2: Cómo funciona */}
      <section className="w-full bg-surface py-16">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-8 text-white">{t('demo_admin_suite.about_title')}</h2>
          
          <div className="space-y-8">
            <div className="bg-elevated border border-line p-8 rounded-xl">
              <p className="text-lg text-white/70 mb-6">
                {t('demo_admin_suite.description_1')}
              </p>

              <p className="text-lg text-white/70 mb-8">
                {t('demo_admin_suite.description_2')}
              </p>

              <div className="mb-8">
                <h3 className="text-xl font-semibold mb-4 text-white">{t('demo_admin_suite.features_title')}</h3>
                
                <div className="mb-6">
                  <h4 className="text-lg font-medium mb-2 text-white">{t('demo_admin_suite.kpis_title')}</h4>
                  <ul className="space-y-2 text-white/70">
                    {kpis.map((kpi, index) => (
                      <li key={index} className="flex items-start">
                        <span className="text-accent-400 mr-2">•</span>
                        {kpi}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="space-y-6">
                  <div>
                    <h4 className="text-lg font-medium mb-2 text-white">{t('demo_admin_suite.licenses_title')}</h4>
                    <p className="text-white/70">{t('demo_admin_suite.licenses_description')}</p>
                  </div>
                  <div>
                    <h4 className="text-lg font-medium mb-2 text-white">{t('demo_admin_suite.end_users_title')}</h4>
                    <p className="text-white/70">{t('demo_admin_suite.end_users_description')}</p>
                  </div>
                  <div>
                    <h4 className="text-lg font-medium mb-2 text-white">{t('demo_admin_suite.organizations_title')}</h4>
                    <p className="text-white/70">{t('demo_admin_suite.organizations_description')}</p>
                  </div>
                  <div>
                    <h4 className="text-lg font-medium mb-2 text-white">{t('demo_admin_suite.schedules_title')}</h4>
                    <p className="text-white/70">{t('demo_admin_suite.schedules_description')}</p>
                  </div>
                </div>
              </div>

              <div className="bg-surface border border-line p-6 rounded-lg">
                <p className="text-white/70">
                  {t('demo_admin_suite.contact_text')}{' '}
                  <a href="mailto:contacto@easyappforz.com" className="text-accent-400 hover:underline">
                    contacto@easyappforz.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección 3: Precios */}
      <section className="w-full bg-ink py-16">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-8 text-white">{t('demo_admin_suite.pricing_title')}</h2>
          <div className="bg-elevated border border-line p-8 rounded-2xl">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
              <div>
                <h3 className="text-2xl font-bold text-white mb-2">{t('demo_admin_suite.price_label')}</h3>
                <div className="flex items-baseline gap-2">
                  <span className="text-4xl font-bold text-white">$6.99</span>
                  <span className="text-white/50">{t('demo_admin_suite.per_instance_month')}</span>
                </div>
              </div>
              <div className="flex flex-col md:flex-row gap-6">
                <a 
                  href="https://www.zendesk.com/in/marketplace/apps/support/1124202/admin-suite/?queryID=92a24b29cd0074ecc59f473198c73f23"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block w-full md:w-auto px-8 py-3 bg-cta text-ink font-semibold rounded-lg hover:bg-cta-hover transition-colors duration-300 text-center"
                >
                  {t('demo_admin_suite.start_trial_button')}
                </a>
                <button 
                  onClick={() => navigate('/', { state: { scrollTo: 'contact' } })}
                  className="w-full md:w-auto px-8 py-3 border border-line text-white font-medium rounded-lg hover:bg-white/5 transition-colors duration-300"
                >
                  {t('demo_admin_suite.schedule_demo_button')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default DemoAdminSuite;
